import { useNavigate } from 'react-router-dom';
import configData from '../config.json';

const FooterComponent = ({categoryList, setActiveCategory, setActiveVideo}) => {

    let navigate = useNavigate(); 
    const navigateTo = (path) =>{ 
        navigate(path);
    }

    const navigateToCategory = (cat) =>{ 
        var path = '/' + (cat.flatName).replace(/\s/g, '-');
        navigate(path);
    }

    const changeActiveCategory = (cat) =>{ 

        var clickedCategory = {};

        categoryList.forEach(element => {
            if(element.id === cat) {
                clickedCategory = element;
            }
        });

        setActiveCategory(clickedCategory);
        setActiveVideo(clickedCategory.videos[0]);
        localStorage.setItem(configData.LOCALSTORAGE.ACTIVE_CATEGORY, JSON.stringify(clickedCategory));
        localStorage.setItem(configData.LOCALSTORAGE.ACTIVE_VIDEO, JSON.stringify(clickedCategory.videos[0]));

        navigateToCategory(clickedCategory);
    }

    if((configData.BRAND).toUpperCase() === 'DELO'){
        var imgSrcBrand = configData.DELO.LOGO;
        var altImgBrand = configData.DELO.ALTIMG;
        var imgClassNameBrand = "d-logo-header d-delo-logo";
        var imgSrcBrandFooter = configData.DELO.LOGOFOOTER;
        var copytightBrand = configData.DELO.COPYRIGHTBRAND;
        var address = configData.DELO.ADDRESS;
        
        var emailLink = configData.DELO.EMAIL_LINK;
        var fbLink = configData.DELO.FACEBOOK_LINK;
        var instagramLink = configData.DELO.INSTAGRAM_LINK;
        var ldnLink = configData.DELO.LINKEDIN_LINK;
        var twitterLink = configData.DELO.TWITTER_LINK;
        var ytLink = configData.DELO.YOUTUBE_LINK;
        
        var deloDOOLink = configData.DELO.DELODOO_LINK;
        var urednistvoLink = configData.DELO.UREDNISTVO_LINK;
        var oglasevanjeLink = configData.DELO.OGLASEVANJE_LINK;
        var delosledLink = configData.DELO.NAPREDNI_IKSLANIK_DELOSLED_LINK;
        var pogojiUporabeLink = configData.DELO.POGOJI_UPORABE_LINK;
        var politikaVarstvaZasebnostiLink = configData.DELO.POLITIKA_VARSTVA_ZASEBNOSTI_LINK;
    }
    else {
        var imgSrcBrand = configData.SLOVENSKENOVICE.LOGO;
        var altImgBrand = configData.SLOVENSKENOVICE.ALTIMG;
        var imgClassNameBrand = "d-logo-header d-novice-logo";
        var imgSrcBrandFooter = configData.SLOVENSKENOVICE.LOGOFOOTER;
        var copytightBrand = configData.SLOVENSKENOVICE.COPYRIGHTBRAND;
        var address = configData.SLOVENSKENOVICE.ADDRESS;
        
        var emailLink = configData.SLOVENSKENOVICE.EMAIL_LINK;
        var fbLink = configData.SLOVENSKENOVICE.FACEBOOK_LINK;
        var instagramLink = configData.SLOVENSKENOVICE.INSTAGRAM_LINK;
        var ldnLink = configData.SLOVENSKENOVICE.LINKEDIN_LINK;
        var twitterLink = configData.SLOVENSKENOVICE.TWITTER_LINK;
        var ytLink = configData.SLOVENSKENOVICE.YOUTUBE_LINK;
        
        var deloDOOLink = configData.SLOVENSKENOVICE.DELODOO_LINK;
        var urednistvoLink = configData.SLOVENSKENOVICE.UREDNISTVO_LINK;
        var oglasevanjeLink = configData.SLOVENSKENOVICE.OGLASEVANJE_LINK;
        var delosledLink = configData.SLOVENSKENOVICE.NAPREDNI_IKSLANIK_DELOSLED_LINK;
        var pogojiUporabeLink = configData.SLOVENSKENOVICE.POGOJI_UPORABE_LINK;
        var politikaVarstvaZasebnostiLink = configData.SLOVENSKENOVICE.POLITIKA_VARSTVA_ZASEBNOSTI_LINK;
    }

    const scroll = () => {
        window.scrollTo({top: 0, left: 0});
      };

    return (
        <>
            <footer id="footer" className="d-section d-footer">
                <div className="container pb-0 ps-md-4 pe-md-4 ps-xxl-0 pe-xxl-0">
                    <div className="row pb-4">
                        <div className="col d-delo-logo-footer" data-aos="fade-right">
                            <div className="d-lg-inline-flex align-items-lg-center flex-grow-lg-1">
                                <img src={imgSrcBrandFooter} className="img-fluid d-max-w-160px-down-md f-logo d-inline-block"  alt={altImgBrand} onClick={() => { navigateTo("/"); scroll(); }}/>
                                {/* <img src="assets/img/Delo_Logo.svg" className="img-fluid d-max-w-160px-down-md f-logo d-inline-block" alt="..." onClick={() => { navigateTo("/"); scroll(); }}/> */}

                                <p className="ms-lg-3 address">{address}</p>
                            </div>

                            <div className="d-social-links">
                                <a href={emailLink} target="_blank"><i className="fa-regular fa-envelope"></i></a>
                                <a href={fbLink} target="_blank"><i className="fa-brands fa-facebook-f"></i></a>
                                <a href={instagramLink} target="_blank"><i className="fa-brands fa-instagram"></i></a>
                                <a href={ldnLink} target="_blank"><i className="fa-brands fa-linkedin-in"></i></a>
                                <a href={twitterLink} target="_blank"><svg className="d-svg-icon"><use xlinkHref="#x-logo-bold" /></svg></a>
                                <a href={ytLink} target="_blank"><i className="fa-brands fa-youtube"></i></a>

                            </div>
                        </div>
                    </div>
                    <div className="row d-footer-copyright d-flex pt-2 gx-0">
                        <div className="col-xxl-3 order-2 order-xxl-1 text-center text-xxl-start f-copy">
                            {/* <p className="copyright">Copyright &copy; {new Date().getFullYear()} {copytightBrand}.<span className="ms-sm-1 d-block d-md-inline">Vse pravice pridržane.</span></p> */}
                            <p className="copyright">Copyright &copy; {copytightBrand} {new Date().getFullYear()}<span className="ms-sm-1 d-block d-md-inline">Vse pravice pridržane.</span></p>
                        </div>
                        <div className="col-xxl-9 order-1 order-xxl-2 mb-2 mt-2 my-lg-0 text-center text-xxl-end f-links">
                           <nav className="d-footer-links">
                            <a className="f-link" href={deloDOOLink} target="_blank">Delo d.o.o.</a>
                            <a className="f-link" href={urednistvoLink} target="_blank" tentacle-id="71d4c7b0815fca1b15c0-1d4">Uredništvo</a>
                            <a className="f-link" href={oglasevanjeLink} target="_blank">Oglaševanje</a>
                            <a className="f-link" href={delosledLink} target="_blank">Napredni iskalnik Delosled</a>
                            <a className="f-link" href={pogojiUporabeLink} target="_blank">Pogoji uporabe</a>
                            <a className="f-link" href={politikaVarstvaZasebnostiLink} target="_blank">Politika varstva zasebnosti</a>
                            <span className="f-link" style={{"cursor": "pointer"}} onClick={() => {window.location.href = `https://trgovina.delo.si/piskotki?back=${window.location.href}`;}}>
                                Piškotki
                            </span>
                            </nav>
                        </div>
                    </div>

                </div>
            </footer>
        </>
    );

}

export default FooterComponent;